<template>
  <div class="col-md-12 mx-auto">
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow :title="user.firstname + ' ' + user.lastname"/>
        <div>
          <button class="show-action-btn edit mr-1" @click="clickOnEditBtn()">
            <pencil-icon size="18"/>
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <b-card class="mt-2 mb-4 shadow-sm">

            <div v-if="isEstateAgent" class="row">
                <span class="col-md-12 bold-text level-two-title my-2 main-red-color">
                  {{ $t('user.personal.infos') }}
                </span>
            </div>

            <div class="row">
              <div class="col-md-4">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('user.Firstname') }}</div>
                  <div> {{ user.firstname }}</div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('user.Lastname') }}</div>
                  <div> {{ user.lastname }}</div>
                </div>
              </div>
              <div class="col-md-4">
                <div v-if="user.masterUserId === null" class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('user.Username') }}</div>
                  <div> {{ user.username }}</div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('user.PhoneNumber') }}</div>
                  <div> {{ user.phoneNumber }}</div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="d-flex flex-column mb-4">
                  <div class="bold-text"> {{ $t('user.Picture') }}</div>
                  <div v-if="user.picture" class="">
                    <img :src="getFileUrl(user.picture.fileUrl)" alt="Logo" class=" mt-1 sidebar-header-logo-user bordered" :class="{ 'reframe':user.picture.reframe }">
                  </div>
                </div>
              </div>
            </div>

            <div v-if="isEstateAgent" class="row">
                <span class="col-md-12 bold-text level-two-title my-2 main-red-color">
                  {{ $t('user.entreprise.infos') }}
                </span>
            </div>


            <div v-if="isEstateAgent" class="row">
              <div class="col-12 col-md-4 col-lg-4 mb-4">
                <div class="bold-text ">
                  {{ $t('user.Entreprise') }}
                </div>
                <div class="mt-2">
                  {{ getValue("entreprise") }}
                </div>
              </div>

              <div class="col-12 col-md-4 col-lg-4 mb-4">
                <div class="bold-text ">
                  {{ $t('user.Address') }}
                </div>
                <div class="mt-2">
                  {{ getValue("address") }} {{ getValue('postalCode') }} {{ getValue('city') }}
                </div>
              </div>

              <div class="col-12 col-md-4 col-lg-4 mb-4">
                <div class="bold-text ">
                  {{ $t('user.CapitalSocial') }}
                </div>
                <div v-if="getValue('capitalSocial') !== 'N/A'" class="mt-2">
                  {{ getValue("capitalSocial") }}€
                </div>
                <div v-else class="mt-2">
                  {{ getValue("capitalSocial") }}
                </div>
              </div>

              <div class="col-12 col-md-4 col-lg-4 mb-4">
                <div class="bold-text ">
                  {{ $t('user.Siret') }}
                </div>
                <div class="mt-2">
                  {{ getValue("siret") }}
                </div>
              </div>

              <div class="col-12 col-md-4 col-lg-4 mb-4">
                <div class="bold-text ">
                  {{ $t('user.Rcs') }}
                </div>
                <div class="mt-2">
                  {{ getValue("rcs") }}
                </div>
              </div>

              <div class="col-12 col-md-4 col-lg-4 mb-4">
                <div class="bold-text ">
                  {{ $t('society.date.exercice.comptable') }}
                </div>
                <div class="mt-2">
                  {{ getValue("dateComptable") !== 'N/A' ? new Date(getValue("dateComptable")).toLocaleDateString('fr-FR') : getValue("dateComptable") }}
                </div>
              </div>
            </div>


            <div v-if="isEstateAgent && user.masterUserId === null && listEntreprises.length > 0" class="row">
                <span class="col-md-12 bold-text level-two-title my-2 main-red-color">
                  {{ $t('user.entreprise.others') }}
                </span>
            </div>

            <div v-for="(entreprise, index) in listEntreprises" v-if="isEstateAgent && user.masterUserId === null && listEntreprises.length > 0" class="row mb-2">
              <div class="row col-12 col-md-4 col-lg-4 mt-2">
                <div class="col-1 bold-text level-two-title main-red-color mt-1">
                  <trash-icon class="cursor-pointer" size="18" @click="confirmRemoveEntreprise(entreprise)"/>
                </div>
                <div class="col-10 mt-2">
                  {{ entreprise.entreprise }}
                </div>
              </div>
            </div>


            <div v-if="isEstateAgent && !this.user.masterUserId" class="row">
                <span class="col-md-12 bold-text level-two-title my-2 main-red-color">
                  {{ $t('user.Abonnement') }}
                </span>
            </div>

            <div v-if="isEstateAgent && !this.user.masterUserId" class="row">
                <span class="col-md-12 bold-text  info-abo">
                  {{ `Pour toute modification de votre abonnement ou pour souscrire à des options supplémentaires, veuillez contacter notre équipe commerciale à l'adresse : ${brandMail}.` }}
                </span>
            </div>

            <div class="row mt-4 container-sub-card" v-if="isEstateAgent && !this.user.masterUserId">
              <template v-if="(user.estateAgent == null && Number(user.creationDate) < 1756166400000) || (user.estateAgent != null && user.estateAgent.creationDate < 1756166400000)">
                <div v-for="(abonnement, index) in abonnementPremiumType" v-if="isEstateAgent && abonnementPremiumType.length > 0" class="col-3 mt-2 sub-card">
                  <subscription-card :operations-per-year="abonnement.maxNbOperations" :type="abonnement.value" :collaborators-per-year="abonnement.maxNbCollaborators" :is-current-plan="currentUserSubscription && currentUserSubscription.value && abonnement.value == currentUserSubscription.value" :current-max-nb-collaborators="currentMaxNbCollaborators" :current-max-nb-operations="currentMaxNbOperations"></subscription-card>
                </div>
              </template>
              <template v-else>
                <div class="col-md-12 mt-2 sub-card">
                  <subscription-lots-card :lots-actifs="nbLotsActifs" :current-max-nb-collaborators="currentMaxNbCollaborators" :current-max-nb-lots="currentMaxNbLots"></subscription-lots-card>
                </div>
              </template>
            </div>

            <div class="row mt-4" v-if="isEstateAgent && !this.user.masterUserId">
              <div class="col-6">
                <b-card v-if="(user.estateAgent == null && Number(user.creationDate) < 1756166400000) || (user.estateAgent != null && user.estateAgent.creationDate < 1756166400000)" class="option-card shadow-sm">
                  <h4 class="card-title">{{ $t('subscription.option1.title') }}</h4>
                  <p>
                    {{ $t('subscription.option1.description') }}
                  </p>
                </b-card>
                <b-card v-else class="option-card shadow-sm">
                  <h4 class="card-title">{{ $t('subscription.option3.title') }}</h4>
                  <p>
                    {{ $t('subscription.option3.description') }}
                  </p>
                </b-card>
              </div>
              <div class="col-6">
                <b-card class="option-card shadow-sm">
                  <h4 class="card-title">{{ $t('subscription.option2.title') }}</h4>
                  <p>
                    {{ $t('subscription.option2.description') }}
                  </p>
                </b-card>
              </div>
            </div>


            <div class="d-flex justify-content-end mt-3">
              <b-button variant="primary" @click="deleteAccount()">{{ $t('myProfile.contact.admin') }}</b-button>
            </div>
          </b-card>
        </div>
      </div>
    </b-container>

    <Item-delete-modal
      id="entrepriseDeleteModal"
      :ref="refModal"
      :beginsWithVoyel="true"
      :isFeminine="true"
      :warning-message="'Delete.societe.warning'"
      :itemSingularName="'entreprise'"
      :selectedItem="this.selectedEntreprise"
      :selectedItemSpecialString="this.selectedEntreprise ? this.selectedEntreprise.entreprise : null"
      controllerName="user"
      itemSingularNameUpp="Entreprise "
      @didDeleteItem="didDeleteEntreprise()">
    </Item-delete-modal>
  </div>
</template>

<script>
import api from "../../services/api";
import backArrow from "../../components/b122/BackArrow";
import DeleteAccountModal from "./DeleteAccountModal";
import ItemDeleteModal from "../../components/b122/ItemDeleteModal.vue";
import {mapActions, mapGetters} from "vuex";
import {bus} from "../../main";
import {format} from 'date-fns';
import SubscriptionCard from "./components/SubscriptionCard";
import SubscriptionLotsCard from "./components/SubscriptionLotsCard.vue";


export default {
  name: "ProfileShow",

  components: {
    SubscriptionLotsCard,
    ItemDeleteModal,
    backArrow,
    DeleteAccountModal,
    SubscriptionCard
  },

  data() {
    return {
      userId: this.$store.getters.userId,
      isEstateAgent: this.$store.getters.isEstateAgent,
      isFreeAccount: null,
      listEntreprises: [],
      refModal: 0,
      selectedEntreprise: null,
      user: {},
      abonnementPremiumType: null,
      currentUserSubscription: null,
      currentMaxNbCollaborators: null,
      currentMaxNbOperations: null,
      currentMaxNbLots: null,
      nbLotsActifs: 0,
    }
  },

  computed: {
    ...mapGetters('brand', ['brandMail']),

    getValue() {
      return property => (this.user[property] || this.user[property] === false) ? this.user[property] : 'N/A'
    },
  },

  mounted() {
    this.fetchData()
  },

  methods: {

    ...mapActions(["updateListEntreprises"]),

    async fetchData() {
      await this.fetchUser()
      await this.getNbLotsActifs()
      await this.getListEntreprises()
      if (this.isEstateAgent) {
        await this.getAbonnementPremiumType()
        await this.fetchUserInfos()
      }
    },

    getPremiumTypeBasedOnValue(abonnementValue) {
      const abonnementPremiumType = this.abonnementPremiumType.find(abonnementPremiumType => abonnementPremiumType.value === abonnementValue)
      return abonnementPremiumType ? abonnementPremiumType : null
    },

    async getListEntreprises() {
      if (this.isEstateAgent && !this.user.masterUserId) {
        await api
          .get(`/user/getListEntreprises/${this.$store.getters.userId}`)
          .then(response => {
            this.listEntreprises = response.data
          })
      }
    },

    async getNbLotsActifs() {
      await api
        .get(`/operationLot/getNbLotsActifs`)
        .then(response => {
          this.nbLotsActifs = response.data.lotsActifs
        })
    },

    async fetchUser() {
      await api
        .get(`/user/getProfile`)
        .then(response => {
          this.user = response.data
          this.isFreeAccount = this.user.subscriptionType === "FREE_ACCOUNT"
        })
        .catch((error) => {
          this.$router.push({
            name: '/',
            params: {
              message: error.response.data.message
            }
          })
        })
    },

    async fetchUserInfos() {
      await api
        .get(`/user/getUserInfos`)
        .then(async response => {
          if (response.data.hasOwnProperty('currentUserSubscription') && response.data.currentUserSubscription !== null) {
            this.currentUserSubscription = this.getPremiumTypeBasedOnValue(response.data.currentUserSubscription)
            this.currentMaxNbOperations = response.data.maxNbOperations
            this.currentMaxNbCollaborators = response.data.maxNbCollaborators
            this.currentMaxNbLots = response.data.maxNbLots
          }
        })
    },


    async getAbonnementPremiumType() {
      await api
        .get(`/userSubscription/getAbonnementPremiumType`)
        .then(async response => {
          this.abonnementPremiumType = response.data
        })
    },

    clickOnEditBtn() {
      this.$router.push({
        name: "ProfileEdit"
      })
    },

    getFileUrl(itemUrl) {
      return process.env.SERVER_URL + itemUrl
    },


    deleteAccount() {
      window.location.href = `mailto:${this.brandMail}`;
    },

    didDeleteEntreprise() {
      this.selectedEntreprise = null
      this.refModal++
      this.getListEntreprises()
      bus.$emit("updateListEntreprises")
    },

    confirmRemoveEntreprise(entreprise) {
      this.selectedEntreprise = entreprise
      this.refModal++
      this.$bvModal.show('entrepriseDeleteModal')
    },
  }
}
</script>

<style scoped>
.info-abo {
  color: var(--tertiary-text-color);
}

.container-sub-card {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.container-sub-card > .sub-card {
  flex: 1;
  display: flex;
  align-items: stretch;
}

.option-card {
  padding: 16px;
  background: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 8px;
  text-align: left;
}

.option-card .card-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 8px;
}

</style>



// WEBPACK FOOTER //
// src/views/user/ProfileShow.vue